import { IDataUtilities } from './IDataUtilities';

class DataUtilities implements IDataUtilities {
    newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    isGuid(val: string): boolean {
        if (!val || val === null) {
            return false;
        }

        return val
            .match(/^[0-9a-fA-F]{8}[-]?[0-9a-fA-F]{4}[-]?[0-9a-fA-F]{4}[-]?[0-9a-fA-F]{4}[-]?[0-9a-fA-F]{12}$/)
            !== null;
    }

    newObjectId() {
        var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
        return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
            return (Math.random() * 16 | 0).toString(16);
        }).toLowerCase();
    }

    isObjectId(val: string): boolean {
        if (!val || val === null) {
            return false;
        }

        return val
            .match(/^[a-fA-F\d]{24}$/)
            !== null;
    }

    isString(val: any): boolean {
        if (val || val === '') { 
            return (typeof val === 'string' || val instanceof String);
        }
        return false;
    }


    private boolValues = [
        'true', 'True', 'false', 'False', '0', '1'
    ];

    isBoolean(val: any, includeNumberAndStringFormats?: boolean): boolean {
        if (val !== undefined) {
            if (typeof val === "boolean") {
                return true;
            }
            if (includeNumberAndStringFormats) {
                if (this.isString(val) && this.boolValues.includes(val)) {
                    return true;
                }
                if (val === 0 || val === 1) {
                    return true;
                }
            }
        }
        return false;
    }

    isNumber(val: any): boolean {
        if (val !== undefined) {
            return Number.isFinite(val);
        }
        return false;
    }

    isDate(val: any, includeNumberAndStringFormats?: boolean): boolean {
        if (val !== undefined) {
            if (val instanceof Date) {
                return true;
            }
            if (includeNumberAndStringFormats) {
                if (this.isNumber(val)) {
                    return true;
                }
                if (this.isString(val)) {
                    try {
                        let test = Date.parse(val as string);
                        if (!Number.isNaN(test)) {
                            return true;
                        }
                    }
                    catch {
                        return false;
                    }
                }
            }
        }
        return false;
    }

    isEnum(enumObject: any, val: any): boolean {
        if (val !== undefined) {
            if (this.isString(val)) {
                //let testVal = val as string;
                if (Object.values(enumObject).includes(val)) {
                    return true;
                }
                if (this.isString(val) && val in enumObject) {
                    return true;
                }

                //try {
                //    if (enumObject[val as any]) {
                //        return true;
                //    }
                //}
                //catch { }
            }

            //if (this.isNumber(val)) {
            //    let testVal = val as number;
            //    if (testVal in enumObject) {
            //        return true;
            //    }
            //}
        }

        return false;
    }

    isArray(val: any): boolean {
        if (val) {
            return Array.isArray(val);
        }
        return false;
    }

    isObject(val: any, excludeNulls?: boolean): boolean {
        if (val) {
            if (excludeNulls) {
                return val !== null && typeof val === 'object' && !Array.isArray(val);
            }
            return typeof val === 'object' && !Array.isArray(val);
        }
        return false;
    }
}

var utilities = new DataUtilities();
export default utilities as IDataUtilities;